export const BUSINESS = {
  name: "Park and Spark Mobile Welding, LLC",
  shortName: "Park & Spark",
  tagline: "Proudly serving Montana for over 20 years",
  phone: "(406) 291-6639",
  phoneHref: "tel:+14062916639",
  email: "parkandsparkwelding@gmail.com",
  emailHref: "mailto:parkandsparkwelding@gmail.com",
  hours: [
    { days: "Monday – Saturday", time: "5:30 AM – 5:00 PM" },
    { days: "Sunday", time: "Closed" },
  ],
  languages: "We speak Spanish and English",
  social: {
    instagram: "https://www.instagram.com/park_and_spark_mobil_welding/",
    linkedin: "https://www.linkedin.com/in/richard-montoya-9581b958",
    yelp: "https://www.yelp.com/biz/park-and-spark-mobile-welding-hardin",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Commercial", to: "/commercial-welding" },
  { label: "Agricultural", to: "/agricultural-welding" },
  { label: "Residential", to: "/residential-welding" },
  { label: "Repairs", to: "/welding-repairs" },
  { label: "Portfolio", to: "/our-work" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_AREAS = [
  "Hardin, MT",
  "Lodge Grass, MT",
  "Crow Agency, MT",
  "Billings, MT",
  "Laurel, MT",
  "Huntley, MT",
  "Shepperd, MT",
  "Ranchester, WY",
  "Dayton, WY",
  "Sheridan, WY",
  "Big Horn County, MT",
  "Yellowstone County, MT",
];

export const WHY = [
  {
    icon: "award",
    title: "20+ Years of Experience",
    text: "Two decades of hands-on welding and metal fabrication expertise on every job.",
  },
  {
    icon: "home",
    title: "Family-Owned & Operated",
    text: "A local, family-run business that treats every customer like a neighbor.",
  },
  {
    icon: "map",
    title: "Free Estimates Within 100 Miles",
    text: "Request a free estimate anywhere within 100 miles of Hardin, MT.",
  },
  {
    icon: "truck",
    title: "Mobile Welding Service",
    text: "We bring the expertise and equipment to your location — big jobs and small.",
  },
];

export const CAPABILITIES = [
  "Wrought Iron Fences",
  "Handrails",
  "Stairs",
  "Gates",
  "Horse Fences",
  "Corrals",
  "Construction Equipment Repairs",
  "Hard-Facing",
  "Emergency Welding & Fabrication Repairs",
];

export const IMG = (file) => `/images/${file}`;

export const SERVICES = {
  commercial: {
    eyebrow: "Commercial Welding",
    title: "Commercial Welding Services in Hardin, MT",
    card: {
      name: "Commercial Welding",
      desc: "Fast repairs and custom fabrication that keep your business and equipment running.",
      image: "fb_453270059.jpg",
    },
    intro:
      "We help businesses protect the structural integrity of their property and keep operations moving — fences, gates, sliding gates, bucket repairs, hard-facing, and bumper reinforcements for towing trailers and hitches, in steel or wood, built to your requirements.",
    beforeAfter: {
      before: { src: "bucket_before.webp", alt: "Excavator bucket teeth before repair" },
      after: { src: "bucket_after.webp", alt: "Excavator bucket after repair" },
    },
    features: [
      {
        title: "Custom Fencing & Gate Welding",
        text: "Durable, secure fences and gates built from steel or wood to meet your business's specific security needs.",
      },
      {
        title: "Mobile Welding for Equipment Repairs",
        text: "Bucket repairs, hard-facing, and bumper reinforcements for towing trailers and hitches — efficient, reliable service that minimizes downtime.",
      },
    ],
    images: [
      { src: "fb_453270059.jpg", alt: "Hard-facing work on excavator bucket teeth" },
      { src: "fb_453063233.jpg", alt: "Equipment repair work at a construction site" },
    ],
  },
  agricultural: {
    eyebrow: "Agricultural Welding",
    title: "Agricultural Welding Services in Hardin, MT",
    card: {
      name: "Agricultural Welding",
      desc: "Tractors, windmills, water tanks, and wind damage — welding that keeps your farm working.",
      image: "img_9139.jpg",
    },
    intro:
      "Sturdy, reliable equipment keeps a farm running. We provide mobile welding for agricultural machinery and structures across the region, so you can focus on your crops and livestock while we keep your equipment solid and durable.",
    features: [
      {
        title: "Tractor Work",
        text: "We fix cracks, breaks, and other damage to your tractor, and fabricate custom parts to meet your specific needs.",
      },
      {
        title: "Windmill Repair",
        text: "Broken blades, damaged towers, and component repairs that keep your windmill — and your water supply — operating efficiently.",
      },
      {
        title: "Water Pipe Casing",
        text: "Fast repairs for damaged water pipe casing, plus custom fabrication to fit your irrigation system.",
      },
      {
        title: "Wind Damage Repair",
        text: "Expert repairs for wind-damaged roofs, siding, and other farm structures.",
      },
      {
        title: "Small Farm Tanks",
        text: "Fixing leaks, cracks, and damage on small water and chemical storage tanks.",
      },
      {
        title: "Water Tanks",
        text: "Repairs that keep the water tanks your operation depends on working correctly.",
      },
    ],
    images: [
      { src: "img_9139.jpg", alt: "Windmill repair work" },
      { src: "img_6612.jpg", alt: "Ranch property served by Park & Spark" },
    ],
  },
  residential: {
    eyebrow: "Residential Welding",
    title: "Residential Welding Services in Hardin, MT",
    card: {
      name: "Residential Welding",
      desc: "Fences, gates, handrails, and custom metalwork for your home — built to last.",
      image: "img_0026.jpg",
    },
    intro:
      "High-quality residential welding and steel fabrication for homeowners — custom metalwork that improves the functionality, security, and look of your home, with steel or wood structures built to last.",
    features: [
      {
        title: "Custom Shop Doors, Carports & More",
        text: "Privacy walls, protective structures, and custom builds in steel and wood — designed to complement your property and enhance its value.",
      },
      {
        title: "Steel Gate Fabrication",
        text: "Sliding, swinging, and rolling gates of all sizes and styles — secure, durable, and built to operate smoothly for years.",
      },
      {
        title: "Custom Steel Hand Railings",
        text: "Hand railings for stairs, balconies, decks, and anywhere you need support — safe, sturdy, and aesthetically pleasing.",
      },
    ],
    images: [
      { src: "img_0026.jpg", alt: "Custom sliding shop doors" },
      { src: "img_6277.jpg", alt: "Custom Kokopelli metal art table" },
    ],
  },
  repairs: {
    eyebrow: "Welding Repairs",
    title: "Welding Repair Services in Hardin, MT",
    card: {
      name: "Welding Repairs",
      desc: "When something breaks, we come to you — fast mobile repairs, big or small.",
      image: "fb_453191652.jpg",
    },
    intro:
      "Equipment failure can't wait. Park and Spark Mobile Welding, LLC offers emergency mobile welding repairs to get you back up and running as quickly as possible — with quick turnaround and attention to detail, done right the first time.",
    beforeAfter: {
      before: { src: "bucket_before.webp", alt: "Excavator bucket teeth before repair" },
      after: { src: "bucket_after.webp", alt: "Excavator bucket after repair" },
    },
    features: [
      {
        title: "Emergency Welding Repairs",
        text: "When machinery breaks down, we come to you and minimize your downtime.",
      },
      {
        title: "Box Trucks & Trailers",
        text: "Repairs that keep your box trucks, trailers, and transportation equipment in excellent condition.",
      },
      {
        title: "Outbuildings",
        text: "Structural repairs, rusted-frame restoration, and reinforcement for garages, carports, barns, and sheds.",
      },
    ],
    images: [
      { src: "img_0768.jpg", alt: "Bucket tooth repair" },
      { src: "fb_453191652.jpg", alt: "Bumper and hitch reinforcement on a work truck" },
    ],
  },
};

export const SERVICE_ORDER = ["commercial", "agricultural", "residential", "repairs"];

export const WORK_PREVIEW = [
  { src: "fb_453063233.jpg", alt: "Equipment work at a construction site" },
  { src: "fb_454475267.jpg", alt: "Weld detail" },
  { src: "img_2554.jpg", alt: "Metal roofing installation" },
  { src: "img_5031.jpg", alt: "Custom steel planter" },
  { src: "img_1142.jpg", alt: "Backyard carport structure" },
  { src: "img_9139.jpg", alt: "Windmill repair" },
];

export const GALLERY = [
  { src: "fb_453270059.jpg", alt: "Hard-facing on bucket teeth" },
  { src: "fb_453064288.jpg", alt: "Hard-facing work on excavator bucket teeth" },
  { src: "fb_453151505.jpg", alt: "Hard-facing welds on heavy equipment" },
  { src: "img_0768.jpg", alt: "Bucket tooth repair" },
  { src: "img_0831.jpg", alt: "Bucket repair before work" },
  { src: "ps_gate_29.jpg", alt: "Welded pump frame repair" },
  { src: "ps_gate_32.jpg", alt: "Snow blower housing repair" },
  { src: "fb_453808269.jpg", alt: "Heavy equipment repair" },
  { src: "ps_gate_39.jpg", alt: "Build-up welds on a machine cutting edge" },
  { src: "fb_453063233.jpg", alt: "Equipment work at a construction site" },
  { src: "20240215_133946.jpg", alt: "Welding repair work on a truck flatbed" },
  { src: "20240215_154858_2.jpg", alt: "Truck bed repair in the shop" },
  { src: "fb_453191652.jpg", alt: "Bumper and hitch reinforcement on a work truck" },
  { src: "fb_453245630.jpg", alt: "Trailer hitch fabrication and repair" },
  { src: "img_0314.jpg", alt: "Custom steel parts" },
  { src: "img_0869.jpg", alt: "Trailer frame repair" },
  { src: "img_0870.jpg", alt: "Trailer repair work" },
  { src: "img_1117.jpg", alt: "Boat trailer repair" },
  { src: "img_1119.jpg", alt: "Trailer weld repair" },
  { src: "img_0077.jpg", alt: "Structural steel fabrication" },
  { src: "ps_gate_28.jpg", alt: "Welded frame fabrication on a work truck" },
  { src: "ps_gate_30.jpg", alt: "Trailer jack and wheel chock fabrication" },
  { src: "ps_gate_01.jpg", alt: "Steel slat gate build in the shop" },
  { src: "ps_gate_02.jpg", alt: "Welded steel slat gate project" },
  { src: "ps_gate_03.jpg", alt: "Steel slat gate project on site" },
  { src: "ps_gate_04.jpg", alt: "Steel slat gate fabrication" },
  { src: "ps_gate_05.jpg", alt: "Steel slat gate build" },
  { src: "ps_gate_06.jpg", alt: "Welded corner joint on steel slat gate" },
  { src: "ps_gate_07.jpg", alt: "Steel channel beam fabrication" },
  { src: "ps_gate_08.jpg", alt: "Welded steel post repair" },
  { src: "ps_gate_09.jpg", alt: "Steel beams ready for assembly" },
  { src: "ps_gate_10.jpg", alt: "Heavy pipe welding project" },
  { src: "ps_gate_11.jpg", alt: "Pipe weld seam detail" },
  { src: "ps_gate_12.jpg", alt: "Level check on welded steel" },
  { src: "ps_gate_14.jpg", alt: "Weld detail on heavy pipe" },
  { src: "ps_gate_20.jpg", alt: "Weld bead on steel plating" },
  { src: "ps_gate_40.jpg", alt: "Circular patch weld on corroded steel" },
  { src: "ps_gate_21.jpg", alt: "New bracket plating on drilling equipment" },
  { src: "ps_gate_22.jpg", alt: "Drill rig repair on site" },
  { src: "ps_gate_13.jpg", alt: "Excavator and barge repair project" },
  { src: "ps_gate_15.jpg", alt: "Seawall piling installation from the barge" },
  { src: "ps_gate_16.jpg", alt: "Deadman anchors on a seawall rebuild" },
  { src: "ps_gate_17.jpg", alt: "Tieback rods on a shoreline seawall" },
  { src: "ps_gate_18.jpg", alt: "Weld bead on steel seawall post" },
  { src: "ps_gate_19.jpg", alt: "Seawall cap and post installation" },
  { src: "ps_gate_33.jpg", alt: "Barge bow rebuild on blocks" },
  { src: "ps_gate_34.jpg", alt: "Welding new plate onto the barge hull" },
  { src: "ps_gate_35.jpg", alt: "Hull plates fitted with pipe jacks" },
  { src: "ps_gate_36.jpg", alt: "Welding the hull seam from inside" },
  { src: "ps_gate_37.jpg", alt: "Chalk layout on a hull beam" },
  { src: "ps_gate_23.jpg", alt: "Rusted bracket repair on a work truck" },
  { src: "ps_gate_24.jpg", alt: "Rusted rack bracket before repair" },
  { src: "ps_gate_25.jpg", alt: "Welded rack bracket after repair" },
  { src: "ps_gate_26.jpg", alt: "Pontoon deck and railing repair" },
  { src: "ps_gate_27.jpg", alt: "Welded channel repair on trailer frame" },
  { src: "img_0026.jpg", alt: "Custom sliding shop doors" },
  { src: "img_1142.jpg", alt: "Backyard carport structure" },
  { src: "img_2554.jpg", alt: "Metal roofing installation" },
  { src: "img_3768_c1.jpg", alt: "Carport build at sunset" },
  { src: "img_3788.jpg", alt: "Carport framing" },
  { src: "img_0952.jpg", alt: "Roof and flashing repair" },
  { src: "img_0953.jpg", alt: "Metal roof repair" },
  { src: "img_2030.jpg", alt: "Fabrication work in progress" },
  { src: "ps_gate_38.jpg", alt: "Welding overhead on heavy steel" },
  { src: "ps_gate_31.jpg", alt: "Leveling a new stair stringer" },
  { src: "fb_454475267.jpg", alt: "Weld detail" },
  { src: "img_0321.jpg", alt: "Fabricated steel boxes" },
  { src: "img_0333.jpg", alt: "Galvanized steel brackets" },
  { src: "img_5031.jpg", alt: "Custom steel planter" },
  { src: "img_6277.jpg", alt: "Custom Kokopelli metal art table" },
  { src: "img_6612.jpg", alt: "Ranch property aerial" },
  { src: "img_9139.jpg", alt: "Windmill repair" },
];
